var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormSideImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 363,
    height: 80,
    viewBox: "0 0 363 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3308_20747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6589 78.6551V71.1725H58.0797V69.4669H51.4775V71.1725H53.7883V78.6551H55.6589Z",
    fill: "url(#paint0_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2032 69.4669V78.6551H70.0739V74.6387H74.3103V78.6551H76.236V69.4669H74.3103V72.8781H70.0739V69.4669H68.2032Z",
    fill: "url(#paint1_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7967 78.6551V76.9495H89.0004V74.6387H92.4666V72.8781H89.0004V71.1725H91.9714V69.4669H87.0748V78.6551H92.7967Z",
    fill: "url(#paint2_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.024 78.6551V69.4669H118.215C120.361 69.4669 122.067 71.0625 122.067 73.0982C122.067 75.464 120.471 77.0596 118.05 77.0596H116.95V78.6551H115.024ZM117.995 75.354C119.316 75.354 120.086 74.5287 120.086 73.2082C120.086 72.1078 119.426 71.1725 118.105 71.1725H116.95V75.354H117.995Z",
    fill: "url(#paint3_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.537 77.4447H132.08L131.475 78.6551H129.494L134.391 69.3019L139.233 78.6551H137.142L136.537 77.4447ZM132.906 75.7391H135.712L134.281 72.8781L132.906 75.7391Z",
    fill: "url(#paint4_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.906 78.6551V71.1725H152.382V69.4669H145.725V71.1725H148.036V78.6551H149.906Z",
    fill: "url(#paint5_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.451 69.4669V78.6551H164.376V74.6387H168.613V78.6551H170.484V69.4669H168.613V72.8781H164.376V69.4669H162.451Z",
    fill: "url(#paint6_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.462 78.6551V74.6387H198.928V72.8781H195.462V71.1725H198.433V69.4669H193.536V78.6551H195.462Z",
    fill: "url(#paint7_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.667 74.0335C208.667 71.4476 210.812 69.3019 213.453 69.3019C216.094 69.3019 218.185 71.4476 218.185 74.0335C218.185 76.6744 216.094 78.8202 213.453 78.8202C210.812 78.8202 208.667 76.6744 208.667 74.0335ZM210.647 74.0335C210.647 75.6841 211.858 77.0045 213.453 77.0045C214.994 77.0045 216.259 75.6841 216.259 74.0335C216.259 72.438 214.994 71.1175 213.453 71.1175C211.858 71.1175 210.647 72.438 210.647 74.0335Z",
    fill: "url(#paint8_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.169 77.0596V78.6551H229.244V69.4669H232.435C234.636 69.4669 236.286 71.0625 236.286 73.0982C236.286 74.7488 235.461 75.9592 234.196 76.5644L236.176 78.6551H233.645L232.105 77.0596H231.169ZM232.27 75.354C233.59 75.354 234.361 74.5287 234.361 73.2082C234.361 72.1078 233.7 71.1725 232.38 71.1725H231.169V75.354H232.27Z",
    fill: "url(#paint9_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.222 74.8588L251.471 69.4669H249.271L251.196 73.2082L250.316 74.8588L247.565 69.4669H245.364L250.261 78.8202L252.132 75.0239L254.167 78.8202L258.844 69.4669H256.863L254.222 74.8588Z",
    fill: "url(#paint10_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.369 77.4447H268.913L268.307 78.6551H266.327L271.168 69.3019L276.065 78.6551H273.974L273.369 77.4447ZM269.738 75.7391H272.544L271.113 72.8781L269.738 75.7391Z",
    fill: "url(#paint11_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.169 77.0596V78.6551H286.243V69.4669H289.435C291.635 69.4669 293.286 71.0625 293.286 73.0982C293.286 74.7488 292.461 75.9592 291.195 76.5644L293.176 78.6551H290.645L289.159 77.0596H288.169ZM289.215 75.354C290.535 75.354 291.305 74.5287 291.305 73.2082C291.305 72.1078 290.645 71.1725 289.325 71.1725H288.169V75.354H289.215Z",
    fill: "url(#paint12_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.701 69.4669C310.342 69.4669 312.488 71.4476 312.488 74.0335C312.488 76.6744 310.342 78.6551 307.701 78.6551H303.96V69.4669H307.701ZM307.701 76.9495C309.296 76.9495 310.562 75.7391 310.562 74.0335C310.562 72.3829 309.296 71.1725 307.701 71.1725H305.885V76.9495H307.701Z",
    fill: "url(#paint13_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4014 50.6504C16.7238 50.6504 14.2846 50.2103 12.0839 49.33C9.88311 48.4497 7.99413 47.1659 6.41692 45.4787C4.83971 43.7914 3.62929 41.7007 2.78567 39.2065C1.90536 36.749 1.46521 33.9247 1.46521 30.7336C1.46521 27.5425 1.96038 24.6998 2.95072 22.2056C3.90439 19.7481 5.2065 17.6757 6.85707 15.9885C8.50764 14.3012 10.4333 12.9991 12.6341 12.0821C14.8348 11.2385 17.1823 10.8167 19.6765 10.8167C21.2537 10.8167 22.6842 10.9267 23.968 11.1468C25.2151 11.3669 26.3155 11.6053 27.2691 11.8621C28.1861 12.1922 28.938 12.5039 29.5249 12.7974C30.1118 13.0908 30.5152 13.2926 30.7353 13.4026L29.1948 17.8591C28.8647 17.6391 28.3878 17.4006 27.7643 17.1439C27.1407 16.8871 26.4438 16.6304 25.6736 16.3736C24.8666 16.0802 24.0047 15.8601 23.0877 15.7134C22.134 15.5667 21.1803 15.4933 20.2267 15.4933C18.2093 15.4933 16.3937 15.8418 14.7798 16.5387C13.1659 17.2356 11.7904 18.2443 10.6534 19.5647C9.51632 20.8852 8.65436 22.4807 8.06749 24.3514C7.44394 26.2587 7.13217 28.3861 7.13217 30.7336C7.13217 33.0077 7.40726 35.0801 7.95745 36.9507C8.47096 38.8214 9.25957 40.4169 10.3233 41.7374C11.387 43.0945 12.7258 44.1399 14.3397 44.8734C15.9169 45.607 17.7692 45.9738 19.8966 45.9738C22.3541 45.9738 24.3898 45.7171 26.0037 45.2036C27.6176 44.69 28.828 44.2316 29.6349 43.8281L31.0104 48.2296C30.7537 48.413 30.2952 48.6331 29.6349 48.8898C28.9747 49.1833 28.1494 49.4584 27.1591 49.7151C26.1687 49.9719 25.0133 50.1919 23.6929 50.3753C22.3724 50.5587 20.9419 50.6504 19.4014 50.6504Z",
    fill: "url(#paint14_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.826 49.8252C34.1832 45.7904 35.5036 42.0491 36.7874 38.6013C38.0712 35.1901 39.3183 31.944 40.5287 28.8629C41.7391 25.7819 42.9495 22.8292 44.1599 20.0049C45.3337 17.2172 46.5441 14.448 47.7912 11.697H52.7979C54.045 14.448 55.2738 17.2172 56.4842 20.0049C57.6579 22.8292 58.8684 25.7819 60.1154 28.8629C61.3259 31.944 62.573 35.1901 63.8567 38.6013C65.1038 42.0491 66.4243 45.7904 67.8181 49.8252H61.9311C59.9504 44.0298 58.0064 38.4546 56.0991 33.0994C54.1917 27.7442 52.2294 22.7191 50.212 18.0242C48.1947 22.6825 46.2323 27.6892 44.325 33.0444C42.4177 38.4362 40.492 44.0298 38.548 49.8252H32.826Z",
    fill: "url(#paint15_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.848 46.0288C87.4232 46.0288 90.2108 44.1215 90.2108 40.3069C90.2108 39.1331 89.9724 38.1245 89.4956 37.2808C88.9821 36.4739 88.3035 35.7586 87.4599 35.1351C86.6163 34.5482 85.6626 34.0347 84.5989 33.5946C83.4985 33.1544 82.3431 32.7143 81.1327 32.2741C79.7389 31.7973 78.4184 31.2471 77.1713 30.6235C75.9242 30.0367 74.8422 29.3214 73.9252 28.4778C73.0082 27.6708 72.293 26.6988 71.7795 25.5618C71.2293 24.4247 70.9542 23.0493 70.9542 21.4354C70.9542 18.0975 72.0912 15.4933 74.3654 13.6227C76.6395 11.752 79.7756 10.8167 83.7736 10.8167C86.0844 10.8167 88.1935 11.0551 90.1008 11.5319C91.9714 12.0455 93.3469 12.5956 94.2272 13.1825L92.5216 17.529C91.7514 17.0522 90.6143 16.5754 89.1105 16.0985C87.5699 15.6584 85.791 15.4383 83.7736 15.4383C82.7466 15.4383 81.7929 15.5483 80.9126 15.7684C80.0323 15.9885 79.2621 16.3186 78.6018 16.7587C77.9416 17.1989 77.4281 17.7491 77.0613 18.4093C76.6578 19.1062 76.4561 19.9132 76.4561 20.8302C76.4561 21.8572 76.6578 22.7191 77.0613 23.416C77.4648 24.113 78.0333 24.7182 78.7669 25.2317C79.5005 25.7819 80.3624 26.277 81.3528 26.7172C82.3064 27.1573 83.3701 27.5975 84.5439 28.0376C86.1945 28.6979 87.7166 29.3581 89.1105 30.0183C90.4676 30.6786 91.6597 31.4672 92.6867 32.3841C93.677 33.3011 94.4473 34.3832 94.9975 35.6303C95.5477 36.914 95.8228 38.4546 95.8228 40.2519C95.8228 43.5897 94.6124 46.1572 92.1915 47.9545C89.734 49.7518 86.2861 50.6504 81.848 50.6504C80.3441 50.6504 78.9686 50.5404 77.7215 50.3203C76.4378 50.1369 75.3007 49.8985 74.3103 49.6051C73.32 49.3483 72.4764 49.0549 71.7795 48.7248C71.0459 48.4313 70.4774 48.1746 70.0739 47.9545L71.6694 43.553C72.5131 44.0298 73.7968 44.5617 75.5208 45.1485C77.2447 45.7354 79.3538 46.0288 81.848 46.0288Z",
    fill: "url(#paint16_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.26 49.8252V11.697H125.533V16.2636H107.597V27.5975H123.552V32.054H107.597V45.2586H126.908V49.8252H102.26Z",
    fill: "url(#paint17_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.889 11.3119C248.244 11.3119 252.37 12.3206 255.268 14.3379C258.129 16.392 259.559 19.4363 259.559 23.4711C259.559 25.6718 259.174 27.5425 258.404 29.083C257.597 30.6602 256.46 31.9256 254.993 32.8793C253.489 33.8697 251.673 34.5849 249.546 35.0251C247.418 35.4652 245.016 35.6853 242.338 35.6853H238.102V49.8252H232.765V12.2472C234.269 11.8804 235.956 11.6236 237.827 11.4769C239.661 11.3669 241.348 11.3119 242.889 11.3119ZM243.329 15.9885C241.055 15.9885 239.312 16.0435 238.102 16.1535V31.1187H242.118C243.952 31.1187 245.603 30.9903 247.07 30.7336C248.537 30.5135 249.784 30.11 250.811 29.5232C251.802 28.973 252.572 28.2027 253.122 27.2124C253.672 26.222 253.947 24.9566 253.947 23.416C253.947 21.9489 253.672 20.7385 253.122 19.7848C252.535 18.8311 251.765 18.0609 250.811 17.474C249.821 16.9238 248.684 16.5387 247.4 16.3186C246.116 16.0985 244.759 15.9885 243.329 15.9885Z",
    fill: "url(#paint18_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.925 49.8252C263.282 45.7904 264.603 42.0491 265.886 38.6013C267.17 35.1901 268.417 31.944 269.628 28.8629C270.838 25.7819 272.049 22.8292 273.259 20.0049C274.433 17.2172 275.643 14.448 276.89 11.697H281.897C283.144 14.448 284.373 17.2172 285.583 20.0049C286.757 22.8292 287.967 25.7819 289.215 28.8629C290.425 31.944 291.672 35.1901 292.956 38.6013C294.203 42.0491 295.523 45.7904 296.917 49.8252H291.03C289.049 44.0298 287.105 38.4546 285.198 33.0994C283.291 27.7442 281.328 22.7191 279.311 18.0242C277.294 22.6825 275.331 27.6892 273.424 33.0444C271.517 38.4362 269.591 44.0298 267.647 49.8252H261.925Z",
    fill: "url(#paint19_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.563 11.697V16.3186H315.569V49.8252H310.232V16.3186H298.238V11.697H327.563Z",
    fill: "url(#paint20_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.163 11.697H362.5V49.8252H357.163V32.2191H338.512V49.8252H333.175V11.697H338.512V27.5975H357.163V11.697Z",
    fill: "url(#paint21_linear_3308_20747)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.837 0.803246C201.019 0.803246 218.735 16.2086 222.256 36.4005C190.62 33.9247 163.331 41.7924 139.453 58.5732C137.582 54.2267 136.647 49.2199 136.647 43.9931C136.647 20.2249 156.069 0.803246 179.837 0.803246ZM220.001 59.7286C204.32 60.7189 201.624 38.7663 222.476 38.8214C222.917 40.4719 223.027 42.2325 223.027 43.9931C223.027 49.6051 221.981 54.9419 220.001 59.7286Z",
    fill: "url(#paint22_linear_3308_20747)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3308_20747",
    x1: 8.89277,
    y1: 78.8202,
    x2: 362.39,
    y2: 78.8202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01998E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFE67"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3308_20747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 361.412,
    height: 79.0588,
    fill: "white",
    transform: "translate(0.794067)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormSideImg);
export default __webpack_public_path__ + "static/media/form-side-img.99a5e276a9ba5c5cfb1bc8351f8e4d28.svg";
export { ForwardRef as ReactComponent };